module.exports = __webpack_public_path__ + "static/media/family.197fab30.png";